import React from 'react'
import FormUser from '../components/FormUser'
import hipladeTemplate from '../../common/template'

function UsersForm() {
  return <FormUser />
}

export default hipladeTemplate(UsersForm)
